import angular from 'angular';

export class FooterComponent {
  constructor(Auth, $scope, Application, $stateParams, $rootScope) {
    'ngInject';
    var vm = this
    vm.next = function() {
			Application.next($stateParams.id);
		}
  }
}

export default angular.module('directives.footer', [])
  .component('footer', {
    template: require('./footer.html'),
    controller: FooterComponent,
    controllerAs: 'vm'
  })
  .name;


// WEBPACK FOOTER //
// ./client/components/footer/footer.component.js